import { render, staticRenderFns } from "./crowdfunding.vue?vue&type=template&id=39d83a2a&"
import script from "./crowdfunding.vue?vue&type=script&lang=js&"
export * from "./crowdfunding.vue?vue&type=script&lang=js&"
import style0 from "./crowdfunding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports